(() => {
  'use strict';
  if (window.TDMajestuosoEditorial) { window.TDMajestuosoEditorial.init(); return; }
  const instances = new WeakMap();
  function initialize(root) {
    if (!root || instances.has(root)) return;
    const data = root.querySelector('#td-majestuoso-product-data');
    const form = root.querySelector('#td-majestuoso-purchase');
    if (!data || !form) return;
    let product;
    try { product = JSON.parse(data.textContent); } catch { return; }
    if (!product?.variants?.length || !product.sizes?.length || !product.colors?.length) return;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    $$('.delivery-line small, details p').forEach(element => {
      [...element.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) node.nodeValue = node.nodeValue.replace(/\$74([.,])900/g, (_, separator) => '$74' + separator + '990');
      });
    });
    const abort = new AbortController();
    const observers = [];
    const listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal: abort.signal });
    const observe = (observer, target, options) => { if (target) observer.observe(target, options); observers.push(observer); return observer; };
    const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
    const t = (key, fallback, values = {}) => String(product.i18n?.[key] || fallback).replace(/\{\{?\s*(\w+)\s*\}?\}/g, (match, name) => values[name] ?? match);
    const requestedLocale = product.locale || document.documentElement.lang || 'es-CL';
    const locale = requestedLocale === 'es' && (!product.currency || product.currency === 'CLP') ? 'es-CL' : requestedLocale;
    const moneyFormat = new Intl.NumberFormat(locale, { style: 'currency', currency: product.currency || 'CLP' });
    const money = amount => moneyFormat.format(Number(amount || 0) / Number(product.moneyDivisor || 100));
    const text = (selector, value) => { const element = $(selector); if (element) element.textContent = value; };
    const hidden = (selector, value) => { const element = $(selector); if (element) element.hidden = value; };
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const variants = product.variants.map(item => ({ ...item, id: String(item.id), sizeId: String(item.sizeId) }));
    const getVariant = id => variants.find(item => item.id === String(id));
    const defaultVariant = getVariant(product.selectedVariantId) || variants.find(item => item.available) || variants[0];
    let variant = getVariant(new URLSearchParams(location.search).get('variant')) || defaultVariant;
    let currentMedia = 0;
    let quantity = 1;
    let pointerStart = null;
    let suppressZoom = false;
    let swipeTimer = 0;
    let stickyFrame = 0;
    let pending = false;
    let destroyed = false;
    let playbackToken = 0;
    const openers = new WeakMap();
    const shippingDefault = $('#shipping-estimate')?.textContent || '';
    const size = () => product.sizes.find(item => String(item.id) === variant.sizeId);
    const color = () => product.colors.find(item => item.id === variant.colorId);
    const gallery = () => product.galleries?.[variant.colorId] || [];
    const medium = () => gallery()[currentMedia];
    const minimum = (selected = variant) => Math.max(1, Number(selected.quantityMin) || 1);
    const increment = (selected = variant) => Math.max(1, Number(selected.quantityStep) || 1);
    const availableMaximum = (selected = variant) => {
      if (!selected.available) return 0;
      const maximum = selected.maxQuantity == null ? Number.MAX_SAFE_INTEGER : Math.max(0, Math.floor(Number(selected.maxQuantity) || 0));
      return Math.max(0, minimum(selected) + Math.floor((maximum - minimum(selected)) / increment(selected)) * increment(selected));
    };
    const safeQuantity = (value, selected = variant) => {
      const low = minimum(selected);
      const requested = Math.max(low, Math.floor(Number(value)) || low);
      return Math.max(low, Math.min(availableMaximum(selected) || low, low + Math.floor((requested - low) / increment(selected)) * increment(selected)));
    };
    const allVideos = () => $$('video');
    const pauseVideos = except => allVideos().forEach(video => { if (video !== except) video.pause(); });
    const overlayOpen = () => Boolean($('dialog[open]') || document.querySelector('cart-drawer.active,cart-notification.active,details.menu-drawer-container[open]'));
    const blocked = () => destroyed || document.hidden || overlayOpen();
    const localeRoot = () => window.Shopify?.routes?.root || '/';
    const cartURL = () => window.routes?.cart_url || localeRoot() + 'cart';
    const event = (name, detail = {}) => document.dispatchEvent(new CustomEvent('td:product-form:submit-' + name, { detail: { formId: form.id, ...detail } }));
    const arrow = '<svg class="td-arrow-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"></path></svg>';
  function updateSticky() {
    const button = $('#add-to-cart');
    const bar = $('#sticky-buy');
    if (!button || !bar) return;
    const hide = button.getBoundingClientRect().bottom > 0 || overlayOpen();
    bar.hidden = hide;
    bar.dataset.hidden = String(hide);
    bar.inert = hide;
    bar.setAttribute('aria-hidden', String(hide));
  }
  function scheduleSticky() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); });
  }
  function openDialog(id, opener) {
    const dialog = $('#' + id.replace(/^#/, ''));
    if (!dialog || dialog.open) return;
    playbackToken++;
    pauseVideos();
    openers.set(dialog, opener || document.activeElement);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else { dialog.setAttribute('open', ''); dialog.scrollIntoView({ block: 'center' }); }
    updateSticky();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); openers.get(dialog)?.focus({ preventScroll: true }); updateSticky(); }
  }
  $$('dialog').forEach(dialog => {
    listen(dialog, 'close', () => { const opener = openers.get(dialog); if (opener?.isConnected) opener.focus({ preventScroll: true }); updateSticky(); });
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
  });

  function renderGallery(reset = false) {
    if (reset) currentMedia = 0;
    if (currentMedia >= gallery().length) currentMedia = 0;
    const item = medium();
    if (!item) return;
    const video = $('#gallery-video');
    if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
    const isVideo = item.type === 'video';
    hidden('#image-open', isVideo);
    hidden('#video-container', !isVideo);
    if (isVideo && video) {
      video.poster = item.poster || '';
      video.src = (matchMedia('(max-width:760px)').matches && item.srcMobile) || item.src;
      video.setAttribute('aria-label', item.alt || item.caption || t('product_video', 'Video del Cubre Sofá Majestuoso'));
      video.preload = 'none';
      video.load();
    } else {
      const image = $('#main-image');
      if (image) {
        image.src = item.src;
        if (item.srcset) image.srcset = item.srcset;
        else image.removeAttribute('srcset');
        image.alt = item.alt || t('product_image', 'Cubre Sofá Majestuoso en {color}', { color: color().label });
      }
    }
    text('#gallery-current', currentMedia + 1);
    text('#gallery-total', gallery().length);
    text('#gallery-caption', item.caption || color().label);
    const thumbs = $('#gallery-thumbs');
    if (thumbs) {
      const hadFocus = thumbs.contains(document.activeElement);
      thumbs.innerHTML = gallery().map((entry, index) => '<button type="button" data-media="' + index + '" aria-current="' + (index === currentMedia) + '" aria-label="' + escape(entry.type === 'video' ? t('view_video', 'Ver video') : t('view_image', 'Ver imagen: {caption}', { caption: entry.caption || color().label })) + '"><img src="' + escape(entry.thumb || entry.poster || entry.src) + '" width="72" height="72" loading="lazy" decoding="async" alt="">' + (entry.type === 'video' ? '<span aria-hidden="true">▷</span>' : '') + '</button>').join('');
      if (hadFocus) thumbs.querySelector('[aria-current="true"]')?.focus({ preventScroll: true });
    }
    ['#gallery-prev', '#gallery-next'].forEach(selector => { if ($(selector)) $(selector).disabled = gallery().length < 2; });
  }
  function availabilityHelp() {
    const help = $('#stock-help');
    if (!help) return;
    help.replaceChildren();
    help.hidden = variant.available;
    if (variant.available) return;
    const label = document.createElement('p');
    label.textContent = t('alternative_help', '{color} en {size} está agotado. Puedes elegir otra combinación:', { color: color().label, size: size().label.toLowerCase() });
    help.append(label);
    const alternatives = variants.filter(item => item.available && item.sizeId === variant.sizeId).concat(variants.filter(item => item.available && item.colorId === variant.colorId));
    const choices = [...new Set(alternatives)].slice(0, 5);
    choices.forEach(item => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.alternative = item.id;
      button.className = 'stock-alternative';
      button.textContent = product.colors.find(value => value.id === item.colorId).label + ' · ' + product.sizes.find(value => value.id === item.sizeId).label;
      help.append(button);
    });
  }
  function syncQuantity() {
    quantity = safeQuantity(quantity);
    const field = $('#quantity');
    if (field) {
      field.value = quantity;
      field.min = minimum();
      field.step = increment();
      if (variant.maxQuantity == null) field.removeAttribute('max');
      else field.max = availableMaximum() || minimum();
      field.readOnly = pending;
      field.disabled = !variant.available;
    }
    const nativeId = form.querySelector('[name="id"]');
    if (nativeId) nativeId.value = variant.id;
    if ($('#minus')) $('#minus').disabled = pending || !variant.available || quantity <= minimum();
    if ($('#plus')) $('#plus').disabled = pending || !variant.available || quantity >= availableMaximum();
    text('#sticky-price', money(variant.price * quantity));
    text('#sticky-selection', size().label + ' · ' + color().label + (quantity > 1 ? ' · ×' + quantity : ''));
    ['#add-to-cart', '#sticky-add'].forEach(selector => {
      const button = $(selector);
      if (!button) return;
      const sticky = selector === '#sticky-add';
      const label = pending ? t('adding', 'Agregando…') : variant.available ? (sticky ? t('add_short', 'Agregar') : t('add', 'Agregar al carrito')) : (sticky ? t('sold_out', 'Agotado') : t('sold_out_combination', 'Combinación agotada'));
      button.disabled = pending || !variant.available;
      button.setAttribute('aria-disabled', String(button.disabled));
      button.setAttribute('aria-busy', String(pending));
      button.innerHTML = escape(label) + (variant.available && !pending ? ' ' + arrow : '');
    });
    $$('#size-options button,#color-options button,.coverage-choices button,[data-alternative]').forEach(button => { button.disabled = pending; });
    if (nativeId?.tagName === 'SELECT') nativeId.setAttribute('aria-disabled', String(pending));
  }
  function selectVariant(id, persist = true) {
    const next = getVariant(id);
    if (!next || pending) return;
    const colorChanged = next.colorId !== variant.colorId;
    variant = next;
    quantity = safeQuantity(quantity);
    text('#color-name', color().label);
    text('#compare-color', color().label);
    text('#size-name', size().label);
    text('#selected-dimensions', size().dimensions);
    text('#piece-count', '1 ' + t('unit', 'unidad'));
    text('#product-price', money(variant.price));
    const saving = Math.max(0, Number(variant.compareAtPrice || 0) - variant.price);
    hidden('#compare-wrap', !saving);
    hidden('#saving-wrap', !saving);
    text('#product-compare', saving ? money(variant.compareAtPrice) : '');
    text('#product-saving', saving ? money(saving) + ' (' + Math.round(saving / variant.compareAtPrice * 100) + '%)' : '');
    text('#availability', variant.available ? t('available', 'Disponible') : t('unavailable_combination', 'Agotado en esta combinación'));
    $('#availability')?.classList.toggle('is-unavailable', !variant.available);
    if ($('#availability')) $('#availability').dataset.available = String(variant.available);
    $$('#size-options [data-size],.coverage-choices [data-size]').forEach(button => {
      const option = variants.find(item => item.sizeId === button.dataset.size && item.colorId === variant.colorId);
      button.setAttribute('aria-pressed', String(button.dataset.size === variant.sizeId));
      button.classList.toggle('is-unavailable', !option?.available);
      button.dataset.available = String(Boolean(option?.available));
      const selectedSize = product.sizes.find(item => item.id === button.dataset.size);
      const optionPrice = option ? money(option.price) : '';
      button.setAttribute('aria-label', selectedSize.label + ' · ' + selectedSize.dimensions + ' · ' + optionPrice + ' · ' + color().label + (!option?.available ? ' · ' + t('option_sold_out', 'Agotado') : ''));
      text('[data-maj-option-price="' + button.dataset.size + '"]', optionPrice);
      text('[data-maj-option-stock="' + button.dataset.size + '"]', option?.available ? '' : t('option_sold_out', 'Agotado'));
      text('[data-maj-compare-price="' + button.dataset.size + '"]', optionPrice);
      text('[data-maj-compare-stock="' + button.dataset.size + '"]', option?.available ? t('available', 'Disponible') : t('option_sold_out', 'Agotado'));
      text('[data-maj-guide-price="' + button.dataset.size + '"]', optionPrice);
      const priceNode = button.querySelector('[data-maj-option-price], [data-maj-compare-price]');
      window.TDOfferBenefits?.render(priceNode, { price: option?.price, compareAtPrice: option?.compareAtPrice, variantId: option?.id, shippingIncluded: option?.shippingIncluded, available: option?.available, currency: product.currency, locale: product.locale });

    });
    $$('#color-options [data-color]').forEach(button => {
      const option = variants.find(item => item.colorId === button.dataset.color && item.sizeId === variant.sizeId);
      button.setAttribute('aria-pressed', String(button.dataset.color === variant.colorId));
      button.classList.toggle('is-unavailable', !option?.available);
      button.dataset.available = String(Boolean(option?.available));
      button.setAttribute('aria-label', product.colors.find(item => item.id === button.dataset.color)?.label + ' · ' + size().label + ' · ' + size().dimensions + (!option?.available ? ' · ' + t('option_sold_out', 'Agotado') : ''));
    });
    clearError();
    availabilityHelp();
    syncQuantity();
    renderGallery(colorChanged);
    if (persist) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(history.state, '', url.pathname + url.search + url.hash); }
  }
    function clearError() { ['#purchase-error', '#sticky-error'].forEach(selector => { const element = $(selector); if (element) { element.hidden = true; element.replaceChildren(); } }); }
    function showError(message, reviewCart = false) {
      ['#purchase-error', '#sticky-error'].forEach(selector => {
        const element = $(selector);
        if (!element) return;
        element.textContent = message;
        if (reviewCart) {
          const link = document.createElement('a');
          link.href = cartURL();
          link.textContent = ' ' + t('cart_review', 'Revisar mi carrito');
          element.append(link);
        }
        element.hidden = false;
      });
    }
    async function existingDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && !customElements.get('cart-drawer')) await Promise.race([customElements.whenDefined('cart-drawer'), new Promise(resolve => setTimeout(resolve, 1500))]);
      return drawer && typeof drawer.open === 'function' ? drawer : null;
    }
    async function refreshSections(sectionIds) {
      const url = new URL(location.href);
      url.searchParams.set('sections', sectionIds.join(','));
      const response = await fetch(url.pathname + url.search, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const sections = await response.json();
      return sectionIds.every(id => typeof sections?.[id] === 'string' && sections[id]) ? sections : null;
    }
    async function reconcileCartError(drawer, sectionIds, id) {
      if (!drawer || !sectionIds.length) return;
      try {
        const response = await fetch(localeRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (!cart.items?.some(item => String(item.variant_id || item.id) === id)) return;
        const sections = await refreshSections(sectionIds);
        if (sections) drawer.renderContents({ ...cart, sections });
      } catch {}
    }
    async function addToCart(trigger) {
      if (pending || !variant.available) return;
      quantity = safeQuantity($('#quantity')?.value || quantity);
      const selectedId = variant.id;
      const selectedQuantity = quantity;
      const body = new FormData(form);
      body.set('id', selectedId);
      body.set('quantity', String(selectedQuantity));
      body.delete('variant');
      pending = true;
      clearError();
      syncQuantity();
      let added = false;
      let hasError = false;
      let drawer;
      let sectionIds = [];
      event('start');
      try {
        drawer = await existingDrawer();
        sectionIds = [...new Set((drawer?.getSectionsToRender?.() || []).map(section => section.id))].filter(Boolean).slice(0, 5);
        drawer?.setActiveElement?.(trigger || document.activeElement);
        if (sectionIds.length) { body.set('sections', sectionIds.join(',')); body.set('sections_url', location.pathname); }
        const response = await fetch(window.routes?.cart_add_url || localeRoot() + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(typeof result.description === 'string' ? result.description : t('add_error', 'No pudimos agregar esta selección. Revisa su disponibilidad.'));
          error.cartReview = true;
          if (response.status === 422 || result.status === 422 || response.status === 400) await reconcileCartError(drawer, sectionIds, selectedId);
          throw error;
        }
        added = true;
        event('success', { response: result });
        if (!drawer || typeof drawer.renderContents !== 'function' || !sectionIds.length) { location.assign(cartURL()); return; }
        if (sectionIds.some(id => !result.sections?.[id])) result.sections = await refreshSections(sectionIds);
        if (!result.sections || sectionIds.some(id => !result.sections[id])) { location.assign(cartURL()); return; }
        if (!destroyed) drawer.renderContents(result);
      } catch (error) {
        if (added) { location.assign(cartURL()); return; }
        hasError = true;
        const ambiguous = error instanceof TypeError || error instanceof SyntaxError;
        const message = ambiguous ? t('cart_uncertain', 'No pudimos confirmar la operación. Revisa tu carrito antes de volver a agregar.') : error.message || t('generic_error', 'No pudimos agregar esta selección. Revisa tu carrito antes de intentarlo otra vez.');
        event('error', { error, message });
        if (!destroyed) showError(message, ambiguous || error.cartReview);
      } finally {
        pending = false;
        if (!destroyed) syncQuantity();
        event('end', { hasError });
      }
    }
  function showZoom(opener) {
    const item = medium();
    if (!item || item.type === 'video' || suppressZoom) return;
    const image = $('#zoom-image');
    if (image) { image.src = item.src; image.alt = item.alt || item.caption || color().label; }
    text('#zoom-caption', item.caption || color().label);
    openDialog('zoom-dialog', opener);
  }
  function moveMedia(delta) { if (!gallery().length) return; currentMedia = (currentMedia + delta + gallery().length) % gallery().length; renderGallery(); }
  listen(root, 'click', event => {
    const button = event.target.closest('button,a');
    if (!button || !root.contains(button)) return;
    if (button.matches('[data-modal]')) { event.preventDefault(); if (button.dataset.modal.replace(/^#/, '') === 'zoom-dialog') showZoom(button); else openDialog(button.dataset.modal, button); }
    if (button.matches('[data-close]')) { event.preventDefault(); closeDialog(button.closest('dialog')); }
    if (button.matches('[data-size]')) {
      event.preventDefault();
      selectVariant(variants.find(item => item.sizeId === button.dataset.size && item.colorId === variant.colorId)?.id);
      if (button.hasAttribute('data-maj-review-selection') && !pending) {
        $('#comprar')?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        $('#color-options [aria-pressed="true"]')?.focus({ preventScroll: true });
      }
    }
    if (button.matches('[data-color]')) { event.preventDefault(); selectVariant(variants.find(item => item.colorId === button.dataset.color && item.sizeId === variant.sizeId)?.id); }
    if (button.matches('[data-alternative]')) selectVariant(button.dataset.alternative);
    if (button.matches('[data-media]')) { const index = Number(button.dataset.media); if (Number.isInteger(index) && gallery()[index]) { currentMedia = index; renderGallery(); } }
  });
  listen($('#quantity'), 'change', () => { if (pending) return; quantity = safeQuantity($('#quantity').value); availabilityHelp(); syncQuantity(); });
  listen($('#minus'), 'click', () => { if (pending) return; quantity -= increment(); availabilityHelp(); syncQuantity(); });
  listen($('#plus'), 'click', () => { if (pending) return; quantity += increment(); availabilityHelp(); syncQuantity(); });
  listen($('#image-open'), 'click', event => showZoom(event.currentTarget));
  listen($('#gallery-prev'), 'click', () => moveMedia(-1));
  listen($('#gallery-next'), 'click', () => moveMedia(1));
  listen($('#gallery-stage'), 'keydown', event => { if (medium()?.type !== 'video' && ['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); moveMedia(event.key === 'ArrowLeft' ? -1 : 1); } });
  listen($('#gallery-stage'), 'pointerdown', event => { if (event.currentTarget?.dataset.tdGalleryStage === 'true') return; if (event.pointerType === 'touch' && medium()?.type !== 'video') pointerStart = { x: event.clientX, y: event.clientY }; });
  listen($('#gallery-stage'), 'pointercancel', () => { pointerStart = null; });
  listen($('#gallery-stage'), 'pointerup', event => { if (event.currentTarget?.dataset.tdGalleryStage === 'true') return; if (!pointerStart) return; const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y; pointerStart = null; if (Math.abs(dx) > 45 && Math.abs(dy) < 70) { suppressZoom = true; moveMedia(dx < 0 ? 1 : -1); clearTimeout(swipeTimer); swipeTimer = setTimeout(() => { suppressZoom = false; }, 300); } });
  listen($('#shipping-region'), 'change', event => {
    const estimate = $('#shipping-estimate');
    if (!estimate) return;
    if (event.currentTarget.value === 'rm') {
      estimate.dataset.tdDeliveryPromise = 'detail';
      window.TDDeliveryPromise?.refresh(estimate);
    } else {
      estimate.removeAttribute('data-td-delivery-promise');
      estimate.removeAttribute('data-td-delivery-state');
      estimate.textContent = event.currentTarget.selectedOptions[0]?.dataset.estimate || product.shippingRegions?.[event.currentTarget.value] || shippingDefault;
    }
  });
  listen(window, 'popstate', () => selectVariant(getVariant(new URLSearchParams(location.search).get('variant'))?.id || defaultVariant.id, false));
  listen(window, 'scroll', scheduleSticky, { passive: true });
  listen(window, 'resize', scheduleSticky, { passive: true });

  listen(form.querySelector('[name="id"]'), 'change', change => { if (pending) { change.target.value = variant.id; return; } selectVariant(change.target.value); });
  listen(form, 'submit', submit => { submit.preventDefault(); addToCart(submit.submitter || document.activeElement); });
  listen($('#sticky-add'), 'click', click => {
    if (click.currentTarget.form === form) return;
    click.preventDefault();
    if (typeof form.requestSubmit === 'function') form.requestSubmit($('#add-to-cart'));
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });
  const lazyVideos = $$('video[data-src]');
  function loadVideo(video) { if (video.getAttribute('src')) { if (video.error) video.load(); return; } video.src = video.dataset.src; video.preload = 'metadata'; video.load(); }
  lazyVideos.forEach(video => {
    const card = video.closest('.video-card');
    const play = card?.querySelector('.video-play');
    const playContent = play?.innerHTML;
    const playLabel = play?.getAttribute('aria-label');
    const error = card?.querySelector('.video-error');
    listen(play, 'click', async () => {
      if (blocked()) return;
      if (window.TDGalleryAutoplay?.managesVideo?.(video)) {
        window.TDGalleryAutoplay.play(video, { manual: true });
        return;
      }
      const token = ++playbackToken;
      pauseVideos(video);
      loadVideo(video);
      if (error) error.hidden = true;
      try { await video.play(); if (token !== playbackToken || blocked()) video.pause(); }
      catch (failure) { if (destroyed || token !== playbackToken || failure?.name === 'AbortError') return; if (error) error.hidden = false; if (play) { play.hidden = false; play.setAttribute('aria-label', t('video_retry_label', 'Reintentar reproducción')); play.textContent = t('video_retry', 'Reintentar video');  } }
    });
    listen(video, 'play', () => { if (blocked()) { video.pause(); return; } pauseVideos(video); if (play) { play.hidden = true; play.innerHTML = playContent; if (playLabel) play.setAttribute('aria-label', playLabel); else play.removeAttribute('aria-label'); } });
    listen(video, 'pause', () => { if (play) play.hidden = false; });
    listen(video, 'ended', () => { if (play) play.hidden = false; });
  });
  allVideos().forEach(video => listen(video, 'play', () => pauseVideos(video)));
  if ('IntersectionObserver' in window) {
    const near = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting && !navigator.connection?.saveData) { loadVideo(entry.target); near.unobserve(entry.target); } }), { rootMargin: '180px 0px', threshold: .01 });
    const visible = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .1 });
    lazyVideos.forEach(video => near.observe(video));
    allVideos().forEach(video => visible.observe(video));
    observers.push(near, visible);
    if ($('#add-to-cart')) observe(new IntersectionObserver(updateSticky, { threshold: 0 }), $('#add-to-cart'));
  }
  listen(document, 'visibilitychange', () => { if (document.hidden) { playbackToken++; pauseVideos(); } });

  const reviews = Array.isArray(product.reviews) ? product.reviews : [];
  const curated = Array.isArray(product.curatedReviews) ? product.curatedReviews : [];
  const grid = $('#home-grid');
  const filters = $('#home-filters');
  const quoteGrid = $('#review-quotes');
  const groups = ['2', '3', '4', 'l'];

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const arrowIcon = () => {
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const attributes = { class: 'td-arrow-icon', viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.35', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' };
    Object.entries(attributes).forEach(([name, value]) => icon.setAttribute(name, value));
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M6 18 18 6M6 6h12v12');
    icon.append(path);
    return icon;
  };
  const normalize = value => String(value || '').trim().toLowerCase();
  const cleanText = value => String(value || '').replace(/\s+/g, ' ').trim();
  const safeUrl = (value, photo = false) => {
    try {
      const url = new URL(value, 'https://thedogs.cl');
      if (url.protocol !== 'https:') return '';
      if (photo) return url.hostname === 'images.loox.io' ? url.href : '';
      return url.hostname === 'thedogs.cl' && url.pathname === '/products/cubre-sofa-majestuoso' ? url.href : '';
    } catch (_) { return ''; }
  };
  const sourceUrl = review => '#looxReviews';
  const dateNode = value => {
    const date = new Date(value);
    const time = element('time');
    if (!Number.isNaN(date.getTime())) {
      time.dateTime = date.toISOString();
      time.textContent = new Intl.DateTimeFormat(locale, {
        day: 'numeric', month: 'short', year: 'numeric', timeZone: 'America/Santiago'
      }).format(date);
    }
    return time;
  };
  const link = (label, url, className) => {
    const node = element('a', className, label);
    node.href = url;
    return node;
  };
  const metadata = review => {
    const meta = element('div', 'home-card-meta');
    const score = Number(review.rating);
    if (Number.isInteger(score) && score >= 1 && score <= 5) {
      const stars = element('span', 'stars', '★'.repeat(score));
      stars.setAttribute('aria-label', t('stars', '{rating} de 5 estrellas', { rating: score }));
      meta.append(stars);
    }
    meta.append(element('span', '', review.verified === true ? t('verified', 'Compra verificada') : t('customer_review', 'Reseña de cliente')));
    return meta;
  };
  const authorFooter = review => {
    const footer = element('footer');
    footer.append(element('strong', '', cleanText(review.author)));
    const date = element('span');
    date.append(dateNode(review.date));
    footer.append(date);
    return footer;
  };

  const homeCard = review => {
    const card = element('article', 'home-card');
    card.dataset.reviewId = String(review.id || '');
    const photo = element('div', 'home-photo');
    const image = element('img');
    const original = reviews.find(item => item.id === review.id);
    const media = original && Array.isArray(original.media)
      ? original.media.find(item => item.type === 'photo' && item.src === review.photo) : null;
    image.width = media && Number(media.width) > 0 ? Number(media.width) : 960;
    image.height = media && Number(media.height) > 0 ? Number(media.height) : 720;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = t('home_photo_alt', 'Majestuoso en casa de {author}. Foto compartida en su reseña.', { author: cleanText(review.author) });
    let unavailable = false;
    const showPhotoLink = () => {
      if (unavailable) return;
      unavailable = true;
      photo.classList.add('image-unavailable');
      const fallback = element('div', 'photo-fallback');
      fallback.append(element('p', '', t('home_photo_open', 'Ver la foto de {author}', { author: cleanText(review.author) })));
      const photoLink = link(t('home_photo_link', 'Ver fotos y reseñas'), sourceUrl(review));
      photoLink.append(' ', arrowIcon());
      fallback.append(photoLink);
      photo.replaceChildren(fallback);
    };
    listen(image, 'error', showPhotoLink, { once: true });
    photo.append(image);
    const imageUrl = safeUrl(review.photo, true);
    if (imageUrl) image.src = imageUrl;
    else showPhotoLink();
    const quote = element('blockquote', '', cleanText(review.text));
    quote.cite = sourceUrl(review);
    card.append(photo, metadata(review), quote, authorFooter(review));
    return card;
  };

  const contextCard = group => {
    const context = element('aside', 'home-context');
    const isSectional = group === 'l';
    context.append(element('h3', '', isSectional ? t('sectional_title', 'Cada tramo cuenta.') : t('coverage_title', 'Encuentra tu cobertura.')));
    context.append(element('p', '', isSectional
      ? t('sectional_help', 'Revisa el asiento principal y el chaise por separado para elegir la cobertura de tu sofá en L.')
      : t('coverage_help', 'Compara el ancho útil del asiento con las medidas de Majestuoso para elegir la cobertura que necesitas.')));
    const button = element('button', 'text-link', t('coverage_guide', 'Ver guía de cobertura'));
    button.append(' ', arrowIcon());
    button.type = 'button';
    button.dataset.modal = 'guide-dialog';
    context.append(button);
    return context;
  };

  if (grid && filters && curated.length) {
    const buttons = Array.from(filters.querySelectorAll('button[data-home-filter]'));
    const render = group => {
      if (!groups.includes(group)) return;
      const selection = curated.filter(review => normalize(review.sizeGroup) === group);
      const content = document.createDocumentFragment();
      selection.forEach(review => content.append(homeCard(review)));
      if (selection.length < 2) content.append(contextCard(group));
      grid.classList.toggle('single', selection.length < 2);
      grid.dataset.homeGroup = group;
      grid.replaceChildren(content);
      grid.scrollLeft = 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(normalize(button.dataset.homeFilter) === group)));
    };
    listen(filters, 'click', event => {
      const button = event.target.closest('button[data-home-filter]');
      if (button && filters.contains(button)) render(normalize(button.dataset.homeFilter));
    });
    listen(filters, 'keydown', event => {
      const index = buttons.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else next = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus();
      render(normalize(buttons[next].dataset.homeFilter));
    });
    const selected = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
    const initial = normalize(selected && selected.dataset.homeFilter);
    render(groups.includes(initial) ? initial : '2');
  }

  if (quoteGrid && reviews.length) {
    const picks = [
      ['euPLfyJ4I', 'Súper buena y cómoda la funda'],
      ['nYAq2Tovs', 'Es muy práctico y se ve muy bien'],
      ['DCaLymgJj', 'Se siente acolchado, cómodo y firme.']
    ];
    const content = document.createDocumentFragment();
    picks.forEach(([id, excerpt]) => {
      const review = reviews.find(item => item.id === id);
      if (!review || !cleanText(review.text).includes(excerpt)) return;
      const card = element('article', 'review-quote');
      card.dataset.reviewId = id;
      const quote = element('blockquote', '', excerpt);
      quote.cite = sourceUrl(review);
      const footer = authorFooter(review);
      footer.append(element('span', '', review.verified === true ? t('verified', 'Compra verificada') : t('customer_review', 'Reseña de cliente')));
      card.append(quote, footer);
      content.append(card);
    });
    quoteGrid.replaceChildren(content);
  }

  const overlayChanged = () => { updateSticky(); if (overlayOpen()) { playbackToken++; pauseVideos(); } };
  $$('dialog').forEach(dialog => observe(new MutationObserver(overlayChanged), dialog, { attributes: true, attributeFilter: ['open'] }));
  document.querySelectorAll('cart-drawer,cart-notification,details.menu-drawer-container').forEach(drawer => observe(new MutationObserver(overlayChanged), drawer, { attributes: true, attributeFilter: ['class', 'open'] }));
  const destroy = () => {
    destroyed = true;
    playbackToken++;
    pauseVideos();
    abort.abort();
    observers.forEach(observer => observer.disconnect());
    if (stickyFrame) cancelAnimationFrame(stickyFrame);
    if (swipeTimer) clearTimeout(swipeTimer);
    delete root.dataset.majReady;
    instances.delete(root);
  };
  instances.set(root, { destroy });
  selectVariant(variant.id, false);
  updateSticky();
  root.dataset.majReady = 'true';
  }
  const init = () => document.querySelectorAll('#td-majestuoso-editorial').forEach(initialize);
  window.TDMajestuosoEditorial = Object.freeze({ init });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches?.('#td-majestuoso-editorial') ? event.target : event.target.querySelector?.('#td-majestuoso-editorial');
    if (root) instances.get(root)?.destroy();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();




